import { langContent } from "../languages";
import type { Language, LangContent } from "../typings";

// Resolves the active language to its content bundle. Replaces the
// copy-pasted if/else chain that used to live in every component:
//
//   const lang = useLanguage(language);
//   lang.index.consultationTitle;
//
export const useLanguage = (language: Language): LangContent => {
  if (language === "Polish") {
    return langContent.Polish;
  }
  // English is not translated yet, so it falls back to Russian.
  return langContent.Russian;
};
